// Login.js
import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingSpinner from "../components/LoadingSpinner";
import {Helmet} from "react-helmet";

const Login = () => {
    const { keycloak, initialized } = useKeycloak();
    const location = useLocation();
    const navigate = useNavigate();

    // Determine where to return after login.
    // Default to home ("/") if no previous location is provided.
    const from = location.state?.from || window.location.origin;

    useEffect(() => {
        if (initialized) {
            if (keycloak.authenticated) {
                // If already authenticated, navigate back to the original page.
                navigate(from, { replace: true });
            } else {
                // Automatically trigger the Keycloak login.
                // Note: keycloak.login() causes a full-page redirect.
                keycloak.login({redirectUri: from});
            }
        }
    }, [initialized, keycloak, from, navigate]);

    return <>
        <Helmet>
            <title>PairCare - Logging in...</title>
        </Helmet>
        <LoadingSpinner statusMessage={"Logging you in"} />
        </>;
};

export default Login;
